import jQuery from "jquery";
window.jQuery = jQuery;
$ = jQuery;

import "emojionearea";
import "jquery.scrollto";
import socketCluster from "socketcluster-client";

$(function() {
    if (typeof sessionStorage === "undefined") {
        sessionStorage = {
            getItem: function() {},
            setItem: function() {}
        };
    }

    var $chatContainer = $("#js-chatContainer");
    var $chatInput = $("#js-chatInput");
    var $chatNum = $("#js-chatNum");
    var $newMessagePrompt = $("#js-newMessagePrompt");
    // var currentDomain = location.protocol+'//'+location.hostname;
    var secure = location.protocol === "https:";
    const socketClusterOptions = {
        // hostname: '10.27.10.42', // just for dev
        port: 2083,
        secure: secure,
        autoReconnect: true
    };
    if (process.env && "NODE_ENV" in process.env && process.env.NODE_ENV === "watch") {
        socketClusterOptions.hostname = '10.27.10.42';
    }
    const socket = socketCluster.connect(socketClusterOptions);
    var chatRoom = $chatContainer.data("chatroom") || "";
    var nickname = $chatContainer.data("chatnickname") || "";
    var isModerator = $chatContainer.data("chatismoderator") === true ? 1 : 0;
    var chatEmail = $chatContainer.data("chatemail") || "";

    // state controls
    var autoScroll = true;

    hideScrollMessage();

    var chatChannel = socket.subscribe(chatRoom);

    // console.log('chatRoom ', chatRoom);
    // console.log('nickname ', nickname);
    var alreadyJoined = sessionStorage.getItem("alreadyJoined") || false;
    //console.log('already joined chat ' , alreadyJoined);

    var chatMessageDirection = ($(window).width() < 992) ? 'top' : 'bottom';

    if (chatMessageDirection === 'top') {
        $newMessagePrompt.find('button').html(hpaTranslatedtext.jitWebinar.newMessagesAbove); // New Messages Above
        $newMessagePrompt.css('top', '14px');
        $newMessagePrompt.css('bottom', 'auto');
    }

    socket.emit("init", { chatRoom: chatRoom, nickname: nickname, alreadyJoined: alreadyJoined, email: chatEmail, isModerator: isModerator }, function(
        err,
        response
    ) {
        // load chat history
        if (err) {
            //console.log('INIT ERR ',err);
        } else {
            //console.log('INIT RESPONSE ', response);
            updateMessages(response, "message");
            if (nickname) {
                sessionStorage.setItem("alreadyJoined", true);
            }
        }
    });

    $newMessagePrompt.on("click", function(e) {
        scrollToLastMessage();
    });

    function scrollToLastMessage() {
        if (chatMessageDirection === 'bottom') {
            $(".chat .messages").scrollTo(".message:last", 100, {
                onAfter: function() {
                    hideScrollMessage();
                }
            });
        } else {
            $(".chat .messages").animate({ "scrollTop": 0 });
            hideScrollMessage();
        }
        autoScroll = true;
    }

    function hideScrollMessage() {
        $newMessagePrompt.hide();
    }

    function showScrollMessage() {
        $newMessagePrompt.show();
    }

    $(".messages").on("scroll", function(e) {
        var $this = $(this);
        if (chatMessageDirection === 'top') {
            var lastMessagePos = $this.find(".message:first").position().top;
            if (lastMessagePos < 0) {
                autoScroll = false;
            } else {
                autoScroll = true;
                hideScrollMessage();
            }
        } else {
            var height = $this.height();
            var lastMessagePos = $this.find(".message:last").position().top;
            if (lastMessagePos > height) {
                autoScroll = false;
            } else {
                autoScroll = true;
                hideScrollMessage();
            }
        }
    });

    // submit the message when enter is Pressed
    $chatInput.emojioneArea({
        pickerPosition: (chatMessageDirection == 'top' ? 'bottom' : 'top'),
        attributes: {
            spellcheck: true
        },
        events: {
            keyup: function(editor, event) {
                if (event.which === 13) {
                    submitChat(this.getText());
                }
            }
        }
    });

    // submit the message when the Send Button is pressed
    $chatContainer.submit(function(e) {
        e.preventDefault();
        submitChat($chatInput.val());
        return false;
    });

    function addLinks(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function(url) {
            return '<a target="_blank" href="' + url + '">' + url + "</a>";
        });
    }

    function submitChat(message) {
        // clear text field
        $chatInput.val("");
        $(".emojionearea-editor").empty();
        // check if the message contains at least one non white space
        if (!/\S/.test(message)) {
            return false;
        }

        //basic check to see if its a link, and put into a a tag
        message = addLinks(message);

        var messageObject = {
            chatRoom: chatRoom,
            message: message,
            isModerator: isModerator,
            nickname: nickname,
            email: chatEmail
        };
        // console.log("submitChat", messageObject);
        socket.emit("chat", messageObject);

        var $button = $(".emojionearea-button");
        if ($button.hasClass("active")) {
            // close the Emoji picker if it is open
            $(".emojionearea-button").trigger("click");
        }
    }

    chatChannel.watch(function(messageObject) {
        if (messageObject.messageType === "updateCount") {
            $chatNum.text(messageObject.count);
        } else if (messageObject.messageType !== "members") {
            updateMessages([messageObject]);
        }
    });

    function updateMessages(messages) {
        var html,
            selector = $(".chat .messages");

        html = "";

        if (messages.length < 1) {
            return;
        }

        if (chatMessageDirection === 'top') {
            messages.reverse();
        }

        messages.forEach(function(messageObject) {
            if (messageObject.messageType === "userJoinedChat") {
                html += '<p class="message-userJoined">' + messageObject.message + "</p>";
            } else if (messageObject.messageType === "userBanned") {
                html += '<p class="message-userBanned">' + messageObject.message + "</p>";
            } else if (messageObject.messageType === "userUnbanned") {
                html += '<p class="message-userUnbanned">' + messageObject.message + "</p>";
            } else if (messageObject.messageType === "chat") {
                // console.log("messageObject", messageObject);
                var admin = messageObject.isModerator === 1 ? " admin" : "";

                html += '<section class="message' + admin + '">';
                html +=
                    '<p class="message-description">' +
                    '<span class="nick">' +
                    messageObject.nickname +
                    ": </span>" +
                    messageObject.message +
                    "</p>";
                html += "</section>";
            }
        });

        if (chatMessageDirection === 'top') {
            selector.prepend(html);
            updateFirstMessageMarginTop();
        } else {
            selector.append(html);
        }

        if (autoScroll) {
            scrollToLastMessage();
        } else {
            showScrollMessage();
        }
    }

    function updateFirstMessageMarginTop() {
        if (chatMessageDirection !== 'top') return;

        const fbshareBox = $('.fbshare-box'),
            courseSalesBox = $('.course-sales-box'),
            messageElements = $('.live-chat .panel .panel-body .chat-content .messages *'),
            firstElement = messageElements.first(),
            secondElement = messageElements.first().next(),
            marginTop = 10;

        let currentBoxElement = false;

        if (fbshareBox.is(':visible')) {
            currentBoxElement = fbshareBox;
        } else if (courseSalesBox.is(':visible')) {
            currentBoxElement = courseSalesBox;
        }

        if (currentBoxElement !== false) {
            var outerHeight = currentBoxElement.outerHeight(true) + marginTop;
            firstElement.css('margin-top', outerHeight + 'px');
            secondElement.css('margin-top', marginTop + 'px');
        }

    }
});



// WEBPACK FOOTER //
// ./js/chat3.js